// The draft gate for "A Model of the AI-Native SDLC". Kept free of image/JSX imports so the
// site chrome (announcement bar), the homepage card and the Playwright spec can read it.
import { PAPER } from './paper.ts';

/**
 * `draft`: reachable by URL (the grdev branch preview is the review link) but hidden — noindex,
 * no JSON-LD, not in the sitemap or smoke tests, no homepage card or catalog entry.
 * Flipping to `published` (with the go-live runbook in the PR done) turns all of that on.
 * The site-wide announcement bar is NOT part of it: see AI_NATIVE_SDLC_ANNOUNCEMENT_BAR.
 */
export type WhitepaperStatus = 'draft' | 'published';

export const AI_NATIVE_SDLC_STATUS: WhitepaperStatus = 'published';

/**
 * The site-wide announcement bar promotes the paper only when this is true AND the paper is
 * published; otherwise it keeps the rebrand announcement. The bar swap has its own sign-off
 * (growth marketing), which may land after launch: publishing alone does not swap the bar.
 * On since launch (2 Nov 2026).
 */
export const AI_NATIVE_SDLC_ANNOUNCEMENT_BAR: boolean = true;

export const AI_NATIVE_SDLC_PATH = '/ai-native-sdlc/';

/** The paper's title (paper.ts, shared with the PDF). */
export const AI_NATIVE_SDLC_TITLE = PAPER.title;

/** The paper in one line (the lede's first sentence): the catalog card's and the homepage card's
 * blurb. Here, not in content.ts, so the homepage's client bundle doesn't take the page copy. */
export const AI_NATIVE_SDLC_SUMMARY =
  'Coding agents have collapsed the time it takes to write code, but delivery has not kept pace.';

/**
 * YYYY-MM-DD; set when publishing. JSON-LD, the sitemap and the card/catalog gating read it.
 * The PDF's build date (30 Oct 2026), so the JSON-LD date falls in the month readers see below.
 */
export const AI_NATIVE_SDLC_DATE_PUBLISHED: string | null = '2026-10-30';

/**
 * The publish month readers see (the hero's "Published" row, the homepage card): the PDF cover's
 * date (paper.ts). Machine-readable dates use the full date above.
 */
export const AI_NATIVE_SDLC_PUBLISHED_LABEL: string = PAPER.date;
